import { createListener } from '@state/store/createListener';
import { priceCalendarFilterActions } from './filter/priceCalendarFilterSlice';
import { handleOnFetchFiltersFulfilled } from './monthly/priceCalendarMonthlySlice';

export const setupPriceCalendarListeners = () => {
  createListener([priceCalendarFilterActions.fetchFilters.fulfilled], async (_action, listenerApi) => {
    listenerApi.dispatch(handleOnFetchFiltersFulfilled());
  });
};
